import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main className="py-20 sm:py-24">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl sm:text-4xl font-bold text-white mb-8">Privacy Policy</h1>
            <p className="text-slate-400 mb-8">Last updated: February 2026</p>
            
            <div className="prose prose-invert max-w-none space-y-8">
              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">1. Introduction</h2>
                <p className="text-slate-300 leading-relaxed">
                  TCUBE FITNESS ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website tcubefitness.com or use our services.
                </p>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">2. Information We Collect</h2>
                <p className="text-slate-300 leading-relaxed mb-4">We may collect information about you in various ways, including:</p>
                <ul className="list-disc list-inside text-slate-300 space-y-2">
                  <li><strong>Personal Data:</strong> Name, email address, phone number, age, gender, and health information you provide when filling out forms or during consultations.</li>
                  <li><strong>Health Information:</strong> Medical history, health conditions, medications, and fitness goals to create personalized programs.</li>
                  <li><strong>Usage Data:</strong> Information about how you access and use our website.</li>
                  <li><strong>Communication Data:</strong> Records of our conversations via WhatsApp, email, or phone calls.</li>
                </ul>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">3. How We Use Your Information</h2>
                <p className="text-slate-300 leading-relaxed mb-4">We use the information we collect to:</p>
                <ul className="list-disc list-inside text-slate-300 space-y-2">
                  <li>Create and manage your fitness and nutrition programs</li>
                  <li>Communicate with you about your progress and appointments</li>
                  <li>Improve our services and website</li>
                  <li>Send you promotional communications (with your consent)</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">4. Data Security</h2>
                <p className="text-slate-300 leading-relaxed">
                  We implement appropriate technical and organizational security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
                </p>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">5. Data Sharing</h2>
                <p className="text-slate-300 leading-relaxed">
                  We do not sell, trade, or rent your personal information to third parties. We may share your information with our team of coaches and medical professionals solely for the purpose of delivering our services to you.
                </p>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">6. Your Rights</h2>
                <p className="text-slate-300 leading-relaxed mb-4">You have the right to:</p>
                <ul className="list-disc list-inside text-slate-300 space-y-2">
                  <li>Access and receive a copy of your personal data</li>
                  <li>Request correction of inaccurate data</li>
                  <li>Request deletion of your data</li>
                  <li>Withdraw consent for marketing communications</li>
                </ul>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">7. Contact Us</h2>
                <p className="text-slate-300 leading-relaxed">
                  If you have questions about this Privacy Policy or wish to exercise your rights, please contact us at:
                </p>
                <p className="text-slate-300 mt-4">
                  <strong>Email:</strong> support@tcubefitness.com<br />
                  <strong>WhatsApp:</strong> +91 9515901777<br />
                  <strong>Address:</strong> Hyderabad, Telangana, India
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
